import * as React from "react";
const SvgZoomOut20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M3 8.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0ZM8.5 1a7.5 7.5 0 1 0 4.55 13.463l3.243 3.244.707.707L18.414 17l-.707-.707-3.244-3.244A7.5 7.5 0 0 0 8.5 1ZM12 9.5H5v-2h7v2Z",
      clipRule: "evenodd"
    })
  );
export default SvgZoomOut20Px;
